import { useEffect, useState } from 'react';
import { pushRecentPage, recentPagesChanged, RECENT_PAGES_STORAGE_KEY } from './recent-pages';

function loadRecentPages(): string[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(RECENT_PAGES_STORAGE_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((t): t is string => typeof t === 'string') : [];
  } catch {
    return [];
  }
}

/**
 * BL-285: trackt besuchte Routen (nur solche mit passendem NavItem, siehe
 * `navItemForPath`) als MRU-Liste in localStorage. `matchedTo` ist bewusst
 * der Aufrufer-Zustand statt eines eigenen `useLocation()`-Aufrufs hier --
 * `AppSidebar` löst den Pfad ohnehin schon gegen `allItems` auf (für die
 * aktive Gruppen-Hervorhebung), ein zweiter, unabhängiger Match hier hätte
 * beide driften lassen können.
 *
 * "/" (Start) wird bewusst NICHT getrackt -- der Link ist immer fix sichtbar
 * oberhalb aller Gruppen, ein "zuletzt besucht"-Eintrag dafür wäre redundant.
 */
export function useRecentPages(matchedTo: string | undefined): string[] {
  const [recent, setRecent] = useState<string[]>(loadRecentPages);

  useEffect(() => {
    if (!matchedTo || matchedTo === '/') return;
    setRecent((prev) => {
      if (!recentPagesChanged(prev, matchedTo)) return prev;
      const next = pushRecentPage(prev, matchedTo);
      try {
        window.localStorage.setItem(RECENT_PAGES_STORAGE_KEY, JSON.stringify(next));
      } catch {
        // Storage nicht verfügbar (Privacy-Mode, Quota voll) -- In-Memory-State
        // bleibt für die Session gültig, nur ohne Persistenz über Reload hinaus.
      }
      return next;
    });
  }, [matchedTo]);

  return recent;
}
